import React from 'react';

interface Props {
  cardData: {
    learnersPlaced: string;
    highestSalary: string;
    industryExpert: string;
    hiringPartners: string;
  };
  name: string;
  type: string;
  img: string;
}

const BoastingCards = ({ cardData, ...props }: Props) => {
  const { name, type, img } = props;

  return (
    <div
      key={type}
      className="!w-[156px] medium:!w-[194px] flex flex-col bg-[#fff] p-[24px] items-center justify-center gap-2 medium:gap-2 rounded-xl"
    >
      <div>
        <img src={img} height={60} width={60} alt={`${type}-img`} />
      </div>
      <div>
        <p className="font-[700] text-[20px] text-[#3d3d3d]">
          {cardData?.[type as keyof typeof cardData]}
        </p>
      </div>
      <div>
        <p className="font-[400] medium:text-[18px] text-[#3d3d3d] small:text-[14px]">{name}</p>
      </div>
    </div>
  );
};

export default BoastingCards;
